import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormObjectService } from "../../core/FieldObject";
import { CGDObj, CGDService } from "../../model/backoffice/cgd-price";
import FormAutoObject from "../../core/FormAutoObject";
import { GetEditorForm } from "../../core/Helper2";

export default function CGDPriceEditor(props) {
  const [editor, setEditor] = props?.editor;
  const [objField, setObjField] = useState([]);
  const [form, setForm] = useState(null); //** Form objects */
  const [data, setData] = useState([]); //** Form data */
  const refForm1 = useRef();
  const userInfo = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();

  /**Form init*/
  useEffect(() => {
    if (editor?.show) {
      buildForm();
      if (editor?.idValue > 0) {
        getOldData();
      }
    }
    return () => {
      setData([]);
    };
  }, [editor?.show]);

  /** Build Form objects */
  const buildForm = async () => {
    setObjField(await FormObjectService.BuildsFormOBJs(CGDObj({})));
  };

  const getOldData = async () => {
    let ret = await CGDService.GetItem(
      { [editor.idFieldName]: editor.idValue },
      userInfo
    );
    if (ret) {
      setData(ret);
    }
  };

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{ items: objField, dataValue: [data, setData], refTo: refForm1 }}
      />
    );
  };

  /** SAVE */
  const actionSave = async () => {
    let fData1 = {
      ...Object.fromEntries(new FormData(refForm1.current)),
      [editor.idFieldName]: editor.idValue,
    };
    //include selector options
    fData1 = FormObjectService.IncludeSelectorKeyField(fData1, objField);
    //change "on" to true
    //   FormObjectService.ConvertSwitchON2Boolean(fData1);
    let ret = await CGDService.SaveItem(fData1, userInfo);
    if (ret != null) {
      // AlertOK("บันทึกเรียบร้อย", dispatch);
      editor.action();
      setEditor({ show: false });
    }
  };

  /** Build Form */
  useEffect(() => {
    renderForm();
  }, [objField, data]);

  return (
    <div>
      <GetEditorForm
        {...{
          title: "ตั้งราคากรม",
          editor: [editor, setEditor],
          form: [form, setForm],
          saveData: actionSave,
        }}
      />
    </div>
  );
}
